import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryButtons from './components/CategoryButtons';
import ProductCatalog from './components/ProductCatalog';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import FeaturedArticles from './components/FeaturedArticles';
import Safety from './components/Safety';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />

      {/* Main site button bar */}
      <section className="py-8 md:py-12 bg-white border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-semibold text-base transition-all shadow-md hover:shadow-lg whitespace-nowrap"
            >
              <i className="ri-external-link-line" />
              CSSBuy Spreadsheet
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-8 py-4 bg-foreground-900 hover:bg-foreground-800 text-white rounded-full font-semibold text-base transition-all shadow-md hover:shadow-lg whitespace-nowrap"
            >
              <i className="ri-shopping-bag-line" />
              Buy It Now
            </a>
          </div>
        </div>
      </section>

      <CategoryButtons />
      <ProductCatalog />
      <HowItWorks />
      <Comparison />
      <FeaturedArticles />
      <Safety />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}